import { configureStore } from "@reduxjs/toolkit";
import appSlice from "./appSlice";
import searchSlice from "./searchSlice";
import apiDataSlice from "./apiDataSlice";
import chatlice from "./chatSlice";
import searchResults from "./searchResults";

const store = configureStore({
    reducer: {
        app: appSlice,
        search: searchSlice,
        apiData: apiDataSlice,
        chat: chatlice,
        searchResults: searchResults,
    },

});

export default store;